/**
 * Creates a debounced function that delays invoking the provided function until after 
 * the specified delay has elapsed since the last time the debounced function was invoked.
 * 
 * @param {Function} func - The function to debounce
 * @param {number} delay - The delay in milliseconds  
 * @returns {Function} - The debounced function
 */
export function debounce(func, delay) {
  let timeoutId;
  
  return function (...args) {
    const context = this;
    
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}